import {InjectionToken} from '@angular/core';
import {environment} from '../environments/environment';

export const APP_GEOSERVICES_URL_SERVER = new InjectionToken<string>(environment.geoServicesUrl);
export const APP_GEOSERVICES_URL = new InjectionToken<string>(environment.geoServicesUrl);
